import React from 'react'
import { useEffect, useState } from "react";
import axios from "axios";

export default function List() {
  
    
  const [users, setUsers] = useState([]);




  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers=()=>{
    axios.get("http://localhost:5000/students")

    .then(res => setUsers(res.data.students))
  };


  const handleDelete = (id)=>
  {
    axios.delete(`http://localhost:5000/studelete/${id}`)

    .then(()=>{
      alert("delete done");
      fetchUsers();
    })
  }




  return (
    <>
    <div className='col-md-10 content'>
       <h1>Now you are in register page</h1>
     <table className="table" border={1}>
     <tr>
      <th>ID</th>
      <th>Name</th>
      <th>Email</th>
      <th>Action</th>
    </tr>
      
     {
        users.map((user, i) => (
   
          <tr>
            <td>{user.id}</td>
            <td>{user.name}</td>
            <td>{user.email}</td>
            <td><button onClick={()=>handleDelete(user.id)} className='btn btn-danger'>Delete</button></td>
          </tr>
        ))
      }
    
     
     </table>
       

    </div>
    </>
  )
}
